import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactSelectAdapter from './ReactSelectAdapter';

export default class ParentDependentSelect extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOption: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedParent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.array
        ]),
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool
    };

    render() {
        const {name, defaultOptionLabel, options, selectedOption, selectedParent, onChange, disabled, hasSpecialIcon} = this.props;

        const castSelectedOption = isNaN(selectedOption) ? selectedOption : parseInt(selectedOption, 10);

        const isArrayParent = Array.isArray(selectedParent);
        const castSelectedParent = isArrayParent ? selectedParent : (isNaN(selectedParent) ? selectedParent : parseInt(selectedParent, 10));

        const availableOptions = isArrayParent
            ? options.filter(option => selectedParent.some(p => option.parents.includes(p)))
            : options.filter(option => option.parents.includes(castSelectedParent));

        const hasParent = isArrayParent ? selectedParent.length > 0 : castSelectedParent !== 0;

        return (
            <React.Fragment>
                {hasParent && availableOptions.length > 0 &&
                    <div className={'selectCustom'}>
                        <ReactSelectAdapter
                            selectedOption={castSelectedOption}
                            name={name}
                            options={availableOptions}
                            onChange={onChange}
                            disabled={disabled}
                            defaultOptionLabel={defaultOptionLabel}
                            hasSpecialIcon={hasSpecialIcon}
                        />
                    </div>
                }
            </React.Fragment>
        );
    }
}

ParentDependentSelect.defaultProps = {
    disabled: false
};



// WEBPACK FOOTER //
// ./src/components/Planner/ParentDependentSelect.js